import React, {useState} from "react";
import AllEvents from "./AllEvents.js";
import MuseumEvents from "./MuseumEvents.js";

const Events = function (props) {
    return (      
         props.data.map((item,index) => (
            <MuseumEvents data={item} key={'Events'+index}/>)).sort((a,b) => {            
                return (props.order ==='past' ? (a.props.data.MuseumEventStartDate > b.props.data.MuseumEventStartDate) : (a.props.data.MuseumEventStartDate < b.props.data.MuseumEventStartDate)) ? -1 : 1;
            })
    );
}
export default Events;
